// extracted by mini-css-extract-plugin
export default {"expandCollapseButton":"styles_expandCollapse_expandCollapseButton__URhQ8"};